export const CreateSpaceTagService = Symbol('CreateSpaceTagService');
export const UpdateSpaceTagService = Symbol('UpdateSpaceTagService');
export const QuerySpaceTagsService = Symbol('QuerySpaceTagsService');
export const DeleteSpaceTagService = Symbol('DeleteSpaceTagService');
